import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import AlertMessage from 'components/AlertMessage';
import classnames from 'classnames';
import getEnv from 'helpers/getEnv';

import ColorPicker from 'components/ColorPicker';

// import RadioBackgroundPosition from 'components/RadioBackgroundPosition';
import StylesRadioImage from 'components/StylesRadioImage';
import LinearGradientButton from 'components/LinearGradientButton';

import bgImgStyle1 from 'images/bg-img-style1.svg';

class BackgroundStyle extends Component {
  acceptBackgroundStyles = (id, value, type, typeValue) => {
    const { acceptBackgroundStyles } = this.props;
    let body = {};
    body[id] = value;

    if (type) {
      body[type] = typeValue;
    }

    acceptBackgroundStyles(body);
  };

  acceptUploadImage = async (id, value) => {
    const { acceptBackgroundStyles } = this.props;
    let body = {};
    body[id] = value;
    await acceptBackgroundStyles(body);
  };

  renderBackgroundImages = () => {
    const { backgroundStyleValues, backgroundImages, thumbImages } = this.props;

    let thumbPath, thumbId;
    if (_.get(backgroundStyleValues, 'image.thumb.url', false)) {
      thumbPath = _.get(backgroundStyleValues, 'image.thumb.url', false);
    } else {
      thumbPath = _.get(
        backgroundStyleValues,
        'previous_style_value.previous_value.thumb.url',
        false,
      )
        ? _.get(
            backgroundStyleValues,
            'previous_style_value.previous_value.thumb.url',
            false,
          )
        : _.get(backgroundStyleValues, 'previous_value.thumb.url', false);
    }

    thumbId = _.get(backgroundStyleValues, 'image_id', false)
      ? _.get(backgroundStyleValues, 'image_id', false)
      : (thumbId = _.get(
          backgroundStyleValues,
          'previous_style_value.image_id',
          false,
        ));
    return (
      <Fragment>
        <StylesRadioImage
          src={bgImgStyle1}
          htmlFor="background-images-style"
          labelClassName={classnames('bg-image-itm__label', {
            'bg-image-itm__label__checked':
              backgroundStyleValues.current_image_used_id === null &&
              backgroundStyleValues.image_src === null,
          })}
          radioName="images"
          radioClassName="bg-image-itm__input invisible"
          alt="image1"
          onChange={() =>
            this.acceptBackgroundStyles(
              'image_id',
              null,
              'overlay_type',
              'image',
            )
          }
        />
        {thumbImages.map(el => (
          <StylesRadioImage
            key={el.id}
            src={el.path}
            htmlFor={`background-images-style${el.id}`}
            labelClassName={classnames('bg-image-itm__label', {
              'bg-image-itm__label__checked':
                backgroundStyleValues.current_image_used_id ===
                  el.id.toString() && !backgroundStyleValues.image.url,
            })}
            radioName="images"
            radioClassName="bg-image-itm__input invisible"
            alt={el.id}
            onChange={e =>
              this.acceptBackgroundStyles(
                'image_id',
                e.target.value,
                'overlay_type',
                'image',
              )
            }
            value={el.id}
          />
        ))}
        {thumbPath && (
          <StylesRadioImage
            key={thumbId}
            src={thumbPath}
            htmlFor="background-images-style${thumbId}"
            labelClassName={classnames('bg-image-itm__label', {
              'bg-image-itm__label__checked':
                backgroundStyleValues.image.thumb.url === thumbPath,
            })}
            radioName="images"
            radioClassName="bg-image-itm__input invisible"
            alt={thumbId}
            onChange={e => {
              this.acceptBackgroundStyles(
                'image_id',
                e.target.value,
                'overlay_type',
                'image',
              );
            }}
            value={thumbId}
          />
        )}
      </Fragment>
    );
  };

  render() {
    const { backgroundStyleValues, isImageLoading } = this.props;
    let palette;
    if (backgroundStyleValues.overlay_type === 'gradient') {
      palette = _.get(backgroundStyleValues, 'overlay_value', false)
        ? _.get(backgroundStyleValues, 'overlay_value', false)
            .split(', ')
            .map(el => {
              return {
                pos: parseInt(el.split(' ')[1].slice(0, -1)) / 100,
                color: el.split(' ')[0],
              };
            })
        : false;
    } else palette = false;
    return (
      <Fragment>
        {isImageLoading && <AlertMessage text="Uploading..." spinner={true} />}
        <h2 className="h2-title">Background</h2>
        <div className="separator-line m-b-40" />
        <div className="style-form m-b-50">
          <div className="style-form__row">
            <div className="style-form__col bg flex full-width">
              <div className="style-form__subtitle top">Background images</div>
              <div className="bg-images-group">
                {this.renderBackgroundImages()}

                <div className="form-group-separator middle ml-0" />
                <div className="add-bg-image">
                  <label
                    htmlFor="add-bg-image-input"
                    className="add-bg-image__label">
                    +
                  </label>
                  <input
                    type="file"
                    id="add-bg-image-input"
                    className="add-bg-image__input invisible"
                    onChange={e => {
                      this.acceptUploadImage('image', e.target.files[0]);
                      e.target.value = '';
                    }}
                  />
                  <div className="add-bg-image__hint">
                    <div className="add-bg-image__text">
                      You should not rely on your background image appearing the
                      same size or in the same position as shown in the preview.
                      It will be positioned and sized differently depending on
                      various screen sizes and aspect ratios.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*<div className="style-form__row">*/}
          {/*<div className="style-form__col bg flex">*/}
          {/*<div className="style-form__subtitle top">*/}
          {/*Background position*/}
          {/*</div>*/}
          {/*<RadioBackgroundPosition*/}
          {/*positionDefaultValue={backgroundStyleValues.position_value}*/}
          {/*changePositionValue={e =>*/}
          {/*this.acceptBackgroundStyles('position_value', e.target.value)*/}
          {/*}*/}
          {/*/>*/}
          {/*</div>*/}
          {/*</div>*/}
          <div className="style-form__row">
            <div className="style-form__col bg flex">
              <div className="style-form__subtitle top">Background overlay</div>
              <div className="bg-images-group">
                <StylesRadioImage
                  src={bgImgStyle1}
                  htmlFor="overlay_value"
                  labelClassName={classnames('bg-image-itm__label', {
                    'bg-image-itm__label__checked':
                      backgroundStyleValues.overlay_type === null ||
                      backgroundStyleValues.overlay_type === 'image',
                  })}
                  radioName="background-overlay-style"
                  radioClassName="bg-image-itm__input invisible"
                  alt="image1"
                  onChange={() =>
                    this.acceptBackgroundStyles(
                      'overlay_value',
                      null,
                      'overlay_type',
                      null,
                    )
                  }
                  checked={backgroundStyleValues.overlay_value === null}
                />
                <div className="bg-image-itm">
                  <label
                    className={classnames('bg-image-itm__label', {
                      'bg-image-itm__label__checked':
                        backgroundStyleValues.overlay_type === 'color',
                    })}>
                    <ColorPicker
                      color={backgroundStyleValues.overlay_value}
                      acceptColor={color =>
                        this.acceptBackgroundStyles(
                          'overlay_value',
                          color,
                          'overlay_type',
                          'color',
                        )
                      }
                    />
                  </label>
                </div>
                <div className="bg-image-itm">
                  <label
                    className={classnames('bg-image-itm__label', {
                      'bg-image-itm__label__checked':
                        backgroundStyleValues.overlay_type === 'gradient',
                    })}
                    style={{
                      background:
                        'linear-gradient(rgb(249, 237, 50) 0%, rgb(238, 42, 123) 60%, rgb(64, 106, 255) 100%)',
                    }}>
                    {' '}
                    <LinearGradientButton
                      palette={palette}
                      color={backgroundStyleValues.overlay_value}
                      acceptColor={color =>
                        this.acceptBackgroundStyles(
                          'overlay_value',
                          color,
                          'overlay_type',
                          'gradient',
                        )
                      }
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default BackgroundStyle;



// WEBPACK FOOTER //
// ./src/scenes/Styles/BackgroundStyle.js